<div class="row">
  <div class="col-lg-2" style="background-color: #F2F2F2">
    <app-admin-menu></app-admin-menu>
  </div>
  <div class="col-lg-10" style="padding-top: 54px;">
    <div class="admin-main-container-content">
      <div class="header-title-admin">{{'' | i18n: 'dealer-management'}}.</div>

      <div class="search-panel">
        <div class="search-label">
          {{'' | i18n: 'search-dealer-name'}}:
        </div>
        <div>
          <input style="width: 150px" type="text" name="dealerName"
            [(ngModel)]="dealerFilter.dealerName" id="dealerName"
            placeholder="{{'' | i18n: 'dealer-name-or-number'}}"
            (keydown.enter)="search()">
          </div>
          <div>
            <button (click)="search()" class="button button-search">
              <i class="fa fa-search" aria-hidden="true"></i>
            </button>
          </div>

          <div>
            <button (click)="clear()" class="button button-search">
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>

        </div>

        <div class="dealer-container">
          <div>
            <input type="text" name="dealerName" [(ngModel)]="ng.dealerName" id="dealerName"
              placeholder="{{'' | i18n: 'dealer-name'}}">
            </div>
            <div>
              <input type="text" name="dealerNumber" [(ngModel)]="ng.dealerNumber" id="dealerNumber"
                placeholder="{{'' | i18n: 'dealer-number'}}">
              </div>
              <div>
                <select [(ngModel)]="ng.dealerRegion">
                  @for (region of regions; track region) {
                    <option [value]="region">{{region}}</option>
                  }
                </select>
              </div>
              <div>
                <input type="text" name="dealerFactor" [(ngModel)]="ng.dealerFactor" id="dealerFactor"
                  placeholder="{{'' | i18n: 'dealer -factor'}}">
                </div>
                <div>
                  <input type="text" name="dealerNumber" [(ngModel)]="ng.buno" placeholder="{{'' | i18n: 'buno'}}">
                </div>
                <div>
                  <input type="text" name="dealerNumber" [(ngModel)]="ng.businessPartnerId"
                    placeholder="{{'' | i18n: 'business-partner-id'}}">
                  </div>
                  <div>
                    <button (click)="addDealer()"
                      [disabled]="!ng.dealerName || !ng.dealerNumber || !ng.dealerRegion || !ng.dealerFactor"
                    class="button button-create-add" style="height: 30px">{{'' | i18n: 'add-dealer'}}</button>
                  </div>
                  @if (displayElement) {
                    <div>
                      <input type="text" name="dealerStreetName" [(ngModel)]="ng.dealerStreet"
                        placeholder="{{'' | i18n: 'dealer-street-name'}}">
                      </div>
                    }
                    @if (displayElement) {
                      <div>
                        <input type="text" name="dealerStreetNumber" [(ngModel)]="ng.dealerStreetNumber"
                          placeholder="{{'' | i18n: 'dealer-street-number'}}">
                        </div>
                      }
                      @if (displayElement) {
                        <div>
                          <input type="text" name="dealerZipCode" [(ngModel)]="ng.dealerZipCode"
                            placeholder="{{'' | i18n: 'dealer-zip-code'}}">
                          </div>
                        }
                        @if (displayElement) {
                          <div>
                            <input type="text" name="dealerCity" [(ngModel)]="ng.dealerCity"
                              placeholder="{{'' | i18n: 'dealer-city'}}">
                            </div>
                          }
                        </div>

                        @if (dealerList) {
                          <div class="form-row-container-dealer">
                            <div class="table-header">
                              <div class="table-header-item-lg">
                                <a (click)="orderBy('dealerName')">{{'' | i18n: 'dealer-name'}}@if (dealerFilter.orderBy == 'dealerName') {
                                  <img
                                    src="{{showDirectionImage()}}" class="sort-img" alt=""/>
                                }</a>
                              </div>
                              <div class="table-header-item-lg">
                                <a (click)="orderBy('dealerNumber')">{{'' | i18n: 'dealer-number'}}@if (dealerFilter.orderBy == 'dealerNumber') {
                                  <img
                                    src="{{showDirectionImage()}}" class="sort-img"
                                    alt=""/>
                                }</a>
                              </div>
                              <div class="table-header-item-lg">
                                <a (click)="orderBy('sapDealerNumber')">SAP {{'' | i18n: 'dealer-number'}}@if (dealerFilter.orderBy == 'sapDealerNumber') {
                                  <img
                                    src="{{showDirectionImage()}}" class="sort-img"
                                    alt=""/>
                                }</a>
                              </div>
                              <div class="table-header-item-lg">
                                <a (click)="orderBy('dealerRegion')">{{'' | i18n: 'dealer-region'}}@if (dealerFilter.orderBy == 'dealerRegion') {
                                  <img
                                    src="{{showDirectionImage()}}" class="sort-img"
                                    alt=""/>
                                }</a>
                              </div>
                              <div class="table-header-item-lg">
                                <a (click)="orderBy('buno')">{{'' | i18n: 'buno'}}@if (dealerFilter.orderBy == 'buno') {
                                  <img
                                    .                                                     src="{{showDirectionImage()}}" class="sort-img"
                                    alt=""/>
                                }</a>
                              </div>
                              <div class="table-header-item-lg">
                                <a (click)="orderBy('businessPartnerId')">{{'' | i18n: 'business-partner-id'}}@if (dealerFilter.orderBy == 'businessPartnerId') {
                                  <img
                                    src="{{showDirectionImage()}}" class="sort-img"
                                    alt=""/>
                                }</a>
                              </div>
                              @if (dealerLinkToProductEnabled) {
                                <div>
                                  @for (c of displayContractTypes; track c) {
                                    <div class="table-header-item-lg">
                                      <a>{{c}}</a>
                                    </div>
                                  }
                                </div>
                              }
                              <div class="table-header-item-lg">
                                {{'' | i18n: 'update'}}
                              </div>
                            </div>
                            @for (d of dealerList.dataList; track d) {
                              <div class="table-list">
                                <div class="table-list-item-lg">
                                  <input type="text" id="dName" [(ngModel)]="d.dealerName">
                                </div>
                                <div class="table-list-item-lg">
                                  <input type="text" id="dNum" [(ngModel)]="d.dealerNumber">
                                </div>
                                <div class="table-list-item-lg">
                                  <input type="text" id="sapDealerNumber" [(ngModel)]="d.sapDealerNumber">
                                </div>
                                <div class="table-list-item-lg">
                                  <select [(ngModel)]="d.dealerRegion">
                                    @for (region of regions; track region) {
                                      <option [value]="region">{{region}}</option>
                                    }
                                  </select>
                                </div>
                                <!--          <div class="table-list-item-lg">-->
                                <!--            <input type="text" id="dNsum" [(ngModel)]="d.dealerFactor">-->
                              <!--          </div>-->
                              <div class="table-list-item-lg">
                                <input type="text" id="bunoNumber" [(ngModel)]="d.buno">
                              </div>
                              <div class="table-list-item-lg">
                                <input type="text" id="buno" [(ngModel)]="d.businessPartnerId">
                              </div>
                              @if (dealerLinkToProductEnabled) {
                                <div>
                                  @for (c of displayContractTypes; track c) {
                                    <div class="table-list-item-lg">
                                      <div class="row">
                                        <span class="col-1"></span>
                                        <input class="col-2" type="checkbox" [checked]="doesDealerHaveContractType(c, d)"
                                          [attr.disabled]="isDealerInYucList(d.dealerName, c) ? null : true"
                                          (change)="updateContractType($event.target, c, d,bonusMalus.value)">
                                          <input (blur)="updateBonusMalus(c,d,bonusMalus.value)" #bonusMalus
                                            [value]="bonusMalusForDealerProduct(c,d)"
                                            [attr.disabled]="isDealerInYucList(d.dealerName, c) ? null : true"
                                            class="col-6" type="number" placeholder="{{'bonus-malus-factor' | i18n:''}}">
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  }
                                  <div class="table-list-item-id">
                                    <button id="update" (click)="updateDealer(d)" class="button update-changes">
                                      {{'' | i18n: 'update-changes'}}
                                    </button>
                                  </div>
                                </div>
                              }
                              <div class="pagecount-container" style="width: 10%; margin-left: 90%;">
                                <button id="removePage" (click)="changePage(-1)" class="button button-page"><img
                                src="assets/images/BMW-previous-144.png" width="20px" height="20px"></button>
                                <div class="page-text-container"> {{ this.dealerFilter.page + 1 }} </div>
                                <button id="addPage" (click)="changePage(1)" class="button button-page"><img
                                src="assets/images/BMW-next-144.png" width="20px" height="20px"></button>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
